(function () {
  var MQ_MOBILE = window.matchMedia('(max-width: 767px)');
  var MQ_SMALL = window.matchMedia('(max-width: 479px)');
  var MQ_TABLET = window.matchMedia('(max-width: 1024px)');

  function getColumns(section) {
    if (MQ_SMALL.matches) return 3;
    if (MQ_MOBILE.matches) return 4;
    if (MQ_TABLET.matches) return 6;

    var fromData = parseInt(section.getAttribute('data-columns-desktop'), 10);
    if (fromData) return fromData;

    var fromVar = parseInt(section.style.getPropertyValue('--engrave-cut-columns'), 10);
    return fromVar || 10;
  }

  function updateSection(section) {
    var grid = section.querySelector('.index-materials__grid');
    var moreBtn = section.querySelector('.index-materials__more');
    if (!grid || !moreBtn) return;

    var items = grid.querySelectorAll('.index-materials__item');
    var maxRows = parseInt(grid.getAttribute('data-max-rows'), 10) || 3;
    var i;

    for (i = 0; i < items.length; i++) {
      items[i].classList.remove('is-collapsed');
    }

    if (!MQ_MOBILE.matches) {
      section.classList.remove('is-expanded');
      moreBtn.hidden = true;
      moreBtn.classList.remove('is-visible');
      moreBtn.textContent = 'More';
      moreBtn.setAttribute('aria-expanded', 'false');
      return;
    }

    var columns = getColumns(section);
    var maxVisible = columns * maxRows;

    if (items.length <= maxVisible) {
      section.classList.remove('is-expanded');
      moreBtn.hidden = true;
      moreBtn.classList.remove('is-visible');
      moreBtn.textContent = 'More';
      moreBtn.setAttribute('aria-expanded', 'false');
      return;
    }

    var expanded = section.classList.contains('is-expanded');

    if (!expanded) {
      for (i = maxVisible; i < items.length; i++) {
        items[i].classList.add('is-collapsed');
      }
      moreBtn.textContent = 'More';
      moreBtn.setAttribute('aria-expanded', 'false');
    } else {
      moreBtn.textContent = 'Show Less';
      moreBtn.setAttribute('aria-expanded', 'true');
    }

    moreBtn.hidden = false;
    moreBtn.classList.add('is-visible');
  }

  function bindSection(section) {
    var moreBtn = section.querySelector('.index-materials__more');
    if (!moreBtn || moreBtn.dataset.bound === 'true') return;

    moreBtn.dataset.bound = 'true';
    moreBtn.addEventListener('click', function () {
      var expanded = section.classList.toggle('is-expanded');
      moreBtn.textContent = expanded ? 'Show Less' : 'More';
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      updateSection(section);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('.index-materials')
      : [];

    if (!sections.length && scope.classList && scope.classList.contains('index-materials')) {
      sections = [scope];
    }

    for (var i = 0; i < sections.length; i++) {
      bindSection(sections[i]);
      updateSection(sections[i]);
    }
  }

  function scheduleInit(root) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        initAll(root);
      });
    } else {
      initAll(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleInit();
    });
  } else {
    scheduleInit();
  }

  function onBreakpointChange() {
    scheduleInit();
  }

  if (typeof MQ_MOBILE.addEventListener === 'function') {
    MQ_MOBILE.addEventListener('change', onBreakpointChange);
    MQ_SMALL.addEventListener('change', onBreakpointChange);
    MQ_TABLET.addEventListener('change', onBreakpointChange);
  } else if (typeof MQ_MOBILE.addListener === 'function') {
    MQ_MOBILE.addListener(onBreakpointChange);
    MQ_SMALL.addListener(onBreakpointChange);
    MQ_TABLET.addListener(onBreakpointChange);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleInit(event.target);
  });
})();
